module.exports = __webpack_public_path__ + "img/intro-blue-shape.75811a7f.svg";